import { DBStore, WebChatDBValue } from './types';

export const dbPut = async <V extends WebChatDBValue>(
  store: DBStore<V>,
  data: V,
  key?: string
): Promise<void> => {
  return store.upsert(data, key);
};

export const dbGet = async <V extends WebChatDBValue>(
  store: DBStore<V>,
  key?: string
): Promise<V | unknown | undefined> => {
  return store.get(key);
};

export const dbDelete = <V extends WebChatDBValue>(
  store: DBStore<V>,
  key?: string
): Promise<void> => {
  return store.delete(key);
};
